define('lib/knockout-validation/rules',['require','exports','module','knockout','i18next','moment','api-access','knockout.validation'],function (require, exports, module) {
    var ko = require('knockout');
    var i18n = require('i18next');
    var moment = require('moment');
    var gotomeet = require('api-access').gotomeet;

    require('knockout.validation');

    var register = function () {
        // Override the default "required"
        // We never want to use their default message
        ko.validation.rules.required = {
            validator: function (value) {
                return value;
            },
            message: ''
        };

        // check if array has at least one item
        // if an array contains 'PRIVATE', check if it has other items as well
        //
        // TODO: Remove this rule from the app. No longer used in the schedule meeting modals.
        // Could be replaced with a simple minLength check.
        ko.validation.rules.oneBuiltIn = {
            validator: function (array) {
                if (array.indexOf('PRIVATE') > -1) {
                    return array.length > 1;
                }
                return array.length > 0;
            },
            message: i18n.t('settings.audio.builtin.required')
        };

        ko.validation.rules.inTheFuture = {
            validator: function (meetingTime) {
                return !meetingTime || meetingTime.diff(moment()) > 0;
            },
            message: i18n.t('meeting.timeError')
        };

        ko.validation.rules.validTime = {
            validator: function (meetingTime) {
                var pattern = /^([01]\d|2[0-3]):?([0-5]\d)$/;
                var pattern2 = /^([01]?\d|2[0-3]):([0-5]\d)$/;
                var pattern3 = /^([01]?[0-9]|2[0-3])$/;
                return pattern.test(meetingTime) || pattern2.test(meetingTime) || pattern3.test(meetingTime);
            },
            // TODO: Not relevant error text,
            // possibly because no translations were done.
            message: i18n.t('meeting.timeError')
        };

        ko.validation.rules.restrictedRegex = {
            validator: function (value) {
                if (!value) {
                    return true;
                }
                var tagRegex = '.*[<>].*';
                var unicodeRegex = '.*\\\\\\d+.*';
                var decimalRegex = '.*&#x?\\d*?;.*';
                var privateRegex = new RegExp(tagRegex + '|' + unicodeRegex + '|' + decimalRegex);
                return value.search(privateRegex) === -1;
            },
            message: i18n.t('error.text.xss')
        };

        ko.validation.rules.urlRegex = {
            validator: function (value) {
                if (value) {
                    var urlRegex = new RegExp('^[\u00C0-\u1FFF\u2C00-\uD7FF\\w0-9_-]+$');
                    return urlRegex.test(value);
                }

                return true;
            },
            message: i18n.t('error.url')
        };

        ko.validation.rules.takenG2mmUrl = {
            async: true,
            validator: function (value, params, callback) {
                if (value) {
                    gotomeet.get(value)
                        .then(function () {
                            callback(false);
                        })
                        .fail(function () {
                            callback(true);
                        });
                } else {
                    callback(true);
                }
            },
            message: i18n.t('gotomeetme.reservation.urlTaken')
        };

        ko.validation.registerExtenders();
    };

    module.exports = {
        register: register
    };
});

